import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "section", "doc", "noResults"]

  connect() {
    console.log("🔍 DocsSearch controller connected")
    console.log("📝 Found", this.sectionTargets.length, "sections")
    console.log("📄 Found", this.docTargets.length, "docs")
  }

  search() {
    const query = this.inputTarget.value.toLowerCase().trim()
    console.log("🔎 Searching for:", query)

    if (query === "") {
      this.showAll()
      this.hideNoResults()
      return
    }

    let hasResults = false

    // Parcourir toutes les sections
    this.sectionTargets.forEach(section => {
      let sectionHasResults = false

      // Récupérer tous les documents de cette section
      const docsInSection = this.docTargets.filter(doc =>
        section.contains(doc)
      )

      docsInSection.forEach(doc => {
        const title = doc.textContent.toLowerCase()

        if (title.includes(query)) {
          doc.style.display = ''
          sectionHasResults = true
          hasResults = true
        } else {
          doc.style.display = 'none'
        }
      })

      // Masquer la section si aucun document ne correspond
      if (sectionHasResults) {
        section.style.display = ''
      } else {
        section.style.display = 'none'
      }
    })

    // Afficher/masquer message "aucun résultat"
    if (hasResults) {
      this.hideNoResults()
    } else {
      this.showNoResults()
    }

    console.log("✅ Search completed. Results found:", hasResults)
  }

  showAll() {
    console.log("👁️ Showing all sections and docs")

    this.sectionTargets.forEach(section => {
      section.style.display = ''
    })

    this.docTargets.forEach(doc => {
      doc.style.display = ''
    })

    this.hideNoResults()
  }

  showNoResults() {
    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.remove('hidden')
    }
  }

  hideNoResults() {
    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.add('hidden')
    }
  }

  clear() {
    this.inputTarget.value = ""
    this.search()
  }
}
